<app-patient-search
  class="mb-10"
  [search]="searchCriteria"
  [list]="patientList"
  [refreshTime]="refreshTime"
  [hideAfter]="hidePatientSearch"
  (onActionClick)="patientOnSelect($event)"
></app-patient-search>
<div class="registration_nav"> </div>
<div class="patient-detail fixed-height" >
  <div class="flex">
    <div class="col-8">
      <div *ngIf="patientInfoDisplay" style="width: 180vh;">
        <img
          class="user-img"
          [src]="patientImage ? patientImage : './assets/images/user.png'"
        />
        <label class="patient-name-label"> {{ patientInfoDisplay }}</label>&nbsp;
        <img
          class="user-img"
          [src]="isVip ? './assets/images/email-icons/vip-icon.png':null"
          *ngIf="isVip"
          style="height: 28px;"
        />
        <img
        class="user-img"
        [src]="isNoteVisible ? './assets/images/chat-alert-light.png':null"
        [matTooltip]="isNoteVisible"
        *ngIf="isNoteVisible"
         style="height: 28px;"
        />
        </div>          
      <div *ngIf="!patientInfoDisplay">
        <label class="patient-name-label">{{
          "RegistrationPage.noPatient" | translate
        }}</label>
      </div>
    </div>
    <div class="col-4 right">
      <a routerLink="../patient-encounter">
        <mat-button
          class="md-icon my-icon-button"
          matTooltip="{{ 'payerInfo.registration' | translate }}"
          aria-label="Registration"
        >
          <img src="assets/images/normal.svg" alt="registration" />
        </mat-button>
      </a>
    </div>
  </div>
</div>

<div *ngIf="patientForm" id="registration">
  <div *ngIf="selectedPatient" class="mt-10 div-table-encounters">
    <table
      mat-table
      [dataSource]="dataSourceEncounters"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="VisitDate">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.visitDate" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.VisitDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="visitType">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.visitType" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.visitType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="VisitNumber">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.visitNo" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.VisitNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Department">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.speciality" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.Department }}
        </td>
      </ng-container>

      <ng-container matColumnDef="DoctorName">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.doctor" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.DoctorName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Payer">
        <th mat-header-cell *matHeaderCellDef>
          {{ "EncounterPage.payer" | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.payer }}
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsEncounters; sticky: true"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumnsEncounters"
      ></tr>
    </table>

    <div class="center" *ngIf="dataSourceEncounters.data.length == 0">
      {{ "EncounterPage.noEncounters" | translate }}
    </div>
  </div>
  <form
    [formGroup]="formRegistration"
    #patientRegForm="ngForm"
    novalidate
    class="mt-10"
    attr.data-automation-attribute="formUserPersonalDetails"
  >
    <div class="form-container">
      <div class="flex">
        <div class="col-2">
          <div class="center">
            <img
              [src]="'assets/images/noavatar_new.png'"
              alt="Patient"
              title="Patient"
              *ngIf="!patientImage"
              class="patient-avatar"
              (click)="uploadImageDialog()"
              attr.data-automation-attribute="imgDefaultUser"
            />
            <img
              [src]="patientImage"
              *ngIf="patientImage"
              alt="Patient"
              title="Patient"
              class="patient-avatarupload"
              (click)="uploadImageDialog()"
              [style.width]="'150px'"
              attr.data-automation-attribute="imgDefaultUser"
            />
          </div>
        </div>
        <div class="col-10">
          <b class="section-head">{{
            "RegistrationPage.basicInformation" | translate
          }}</b>
          
          <!-- <mat-grid-list cols="12" rowHeight="60px">
            <mat-grid-tile [colspan]="4">
               <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "RegistrationPage.primaryID" | translate
                }}</mat-label>
                <mat-select
                  [required]="mandatoryField.identificationType"
                  attr.data-automation-attribute="encounterDoctor"
                  formControlName="primaryId"
                  (selectionChange)="primaryIdentificationOnChange($event)"
                  [readonly]="isDisabled"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="primaryIdSearch"
                      [placeholderLabel]="'RegistrationPage.search' | translate"
                    ></ngx-mat-select-search>
                  </mat-option>

                  <mat-option
                    *ngFor="let option of primaryIdFilteredList"
                    [value]="option.code"
                  >
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="4">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label
                  >{{ "RegistrationPage.primaryDocNo" | translate }}
                </mat-label>
                <input
                  [pattern]="primaryIdRegex"
                  matInput
                  formControlName="primaryNumber"
                  [parentForm]="formRegistration"
                  [maxlength]="maxIdentificationLength"
                  [minlength]="minIdentificationLength"
                  [required]="mandatoryField.identificationNo"
                  [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                  attr.data-automation-attribute="txtPrimaryIDDesc"
                  (keyup)="primaryNumberOnKeyUp($event.target.value)"
                  pattern="[a-zA-Z0-9]+"
                  (input)="inputValidation.replaceSpaces($event)"
                  (focusout)="onFocusOutEvent($event.target.value)"
                  [readonly]="isDisabled"
                />
              </mat-form-field>
            </mat-grid-tile>

            <mat-grid-tile [colspan]="4">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label
                  >{{ "RegistrationPage.expiryDate" | translate }}
                </mat-label>
                <input
                  [required]="isexpiryDate"
                  matInput
                  formControlName="expiryDate"
                  [min]="now"
                  [max]="maxExpiry"
                  [matDatepicker]="picker2"
                  [placeholder]="'RegistrationPage.expiryDate' | translate"
                  attr.data-automation-attribute="dateExpiry"
                  name="acb"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list> -->

          <div class="table-container">
            <table mat-table [dataSource]="identificationList" class="mat-elevation-z8">

              <!-- Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-select   
                      [value]="element.type" 
                      (change)="onTypeChange($event.value, index)"
                      [disabled]="element.isCopied">
                      <mat-option value="P" [disabled]="hasPrimarySelected() && element.type !== 'P'">Primary</mat-option>
                      <mat-option value="S">Secondary</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Identification Type Column -->
              <ng-container matColumnDef="idType">
                <th mat-header-cell *matHeaderCellDef>
                  Identification Type <span *ngIf="mandatoryField.identificationType" class="red">*</span>
                </th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline">
                    <mat-select
                      [value]="element.idType"
                      [disabled]="element.isCopied ||element.identifierUUID "
                      (selectionChange)="primaryIdentificationOnChange($event, true, index)"
                      placeholder="Identification Type"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="element.type === 'P' ? primaryIdSearch : secondaryIdSearch"
                          [placeholderLabel]="'RegistrationPage.search' | translate"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let option of element.type === 'P' ? primaryIdFilteredList : secondaryIdFilteredList" 
                      [value]="option.code"
                      [disabled]="isIdTypeSelected(option.code, index)">
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Identification Number Column -->
              <ng-container matColumnDef="idNumber">
                <th mat-header-cell *matHeaderCellDef>
                  Identification Number <span *ngIf="mandatoryField.identificationNo" class="red">*</span>
                </th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': !element.isIdNumberValid }">
                    <input
                      matInput
                      [value]="element.idNumber"
                      [pattern]="element.primaryIdRegex"
                      [attr.maxlength]="element.maxIdentificationLength"
                      [attr.minlength]="element.minIdentificationLength"
                      [placeholder]="'RegistrationPage.primaryDocNo' | translate"
                      [disabled]="element.isCopied"
                      (input)="primaryNumberOnKeyUp($event.target.value, index)"
                      (focusout)="onFocusOutEvent(element, index)"
                    />
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Expiry Date Column -->
              <ng-container matColumnDef="expDate">
                <th mat-header-cell *matHeaderCellDef>Expiry Date</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': element.isExpiryRequired && !element.expDate}">
                    <input
                      matInput
                      readonly
                      [value]="element.expDate"
                      [required]="element.isExpiryRequired"
                      [min]="now"
                      [max]="maxExpiry"
                      [matDatepicker]="picker2"
                      [placeholder]="element.isExpiryRequired? 'Expiry Date *' : 'Expiry Date'"
                      attr.data-automation-attribute="dateExpiry"
                      name="acb"
                      (dateChange)="onExpiryDateChange($event.value, element)"
                      [disabled]="element.isCopied || !element.isExpiryRequired"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Issuing Country Column -->
              <ng-container matColumnDef="issuingCountry">
                <th mat-header-cell *matHeaderCellDef>Issuing Country</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <mat-form-field class="full-width" appearance="outline" [ngClass]="{ 'field-error': element.isCountryRequired && !element.issuingCountry }">
                    <mat-select 
                      [required]="element.isCountryRequired"
                      [value]="element.issuingCountry"
                      (selectionChange)="setCountryValue($event.value, index,element)"
                      [disabled]="isDisabled || element.isCopied"
                      [placeholder]="element.isCountryRequired ? 'Select Country *' : 'Select Country'"
                    >
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="countrySearch"
                        [placeholderLabel]="'RegistrationPage.search' | translate"
                      ></ngx-mat-select-search>
                    </mat-option>
                      <mat-option *ngFor="let country of countryPrimaryList" [value]="country.code">
                        {{ country.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </ng-container>
            
              <!-- Action Buttons Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element; let index = index" class="payer-info">
                  <ng-container *ngIf="!element.isCopied">
                    <button
                      mat-mini-fab
                      matTooltip="Add"
                      class="min-btn btnCyan"
                      (click)="addIdentification(element)"
                    >
                      <mat-icon>add</mat-icon>
                    </button>
                    &nbsp;&nbsp;
                    <button
                      *ngIf="element.type !== 'P'"
                      mat-mini-fab
                      matTooltip="Delete"
                      class="min-btn btnRed"
                      (click)="deleteIdentification(index,element)"
                    >
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                    <button 
                      mat-mini-fab 
                      matTooltip="Copy"
                      style="background-color: white" 
                      *ngIf="element.type == 'P' && selectedPatient && element.idType" 
                      (click)="copyPrimaryId(element, index)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </ng-container>
                </td>
              </ng-container>
            
              <!-- Row Definitions -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            </table>
            
          </div>
        </div>
      </div>
    </div>
    <div class="form-container" attr.data-automation-attribute="divIDDetails">
      <b class="section-head">{{
        "RegistrationPage.personalInformation" | translate
      }}</b>
      <mat-grid-list cols="8" rowHeight="60px">
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.title"
            [label]="'RegistrationPage.prefix' | translate"
            [masterName]="masterAPI.PREFIX_MASTER"
            [formControlName]="'prefix'"
            [defaultValue]="selectedPatient ? selectedPatient.title : ''"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
            (itemSelected)="getGender($event)"
            (autoLoadCompleted)="getGender($event)"
          >
          </app-master-form-field>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "RegistrationPage.name" | translate }}</mat-label>
            <input
              pattern="([a-zA-Z,'-./!@#$%^&*\s]+)"
              matInput
              maxlength="100"
              oninput="this.value = this.value.replace(/\d+/g, '').toUpperCase()"
              formControlName="firstName"
              [placeholder]="'RegistrationPage.name' | translate"
              [parentForm]="formRegistration"
              [required]="mandatoryField.fullName"
              attr.data-automation-attribute="txtFirstName"
            />
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.gender"
            [label]="'RegistrationPage.gender' | translate"
            [masterName]="masterAPI.GENDER_MASTER"
            [formControlName]="'gender'"
            [parentForm]="formRegistration"
            [defaultValue]="genderValue"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
      </mat-grid-list>

      <mat-grid-list cols="8" rowHeight="60px">
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "RegistrationPage.dobForm" | translate }}</mat-label>
            <input
              matInput
              formControlName="dateOfBirth"
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="picker1"
              [required]="mandatoryField.dateOfBirth"
              [placeholder]="'RegistrationPage.dobForm' | translate"
              [parentForm]="formRegistration"
              attr.data-automation-attribute="dateDOB"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <div class="patient-age">
            <div class="year">
              <input
                matInput
                attr.data-automation-attribute="txtpatientageYears"
                [value]="patientAge?.years"
                (keyup)="calculateDob($event.target.value, 0)"
              />
              <span class="unit">Y</span> 
            </div>
            <div class="months">
              <input
                matInput
                attr.data-automation-attribute="txtpatientageMonths"
                value="{{ patientAge?.months }}"
                (keyup)="calculateDob(patientAge?.years, $event.target.value)"
                [parentForm]="formRegistration"
              />
              <span class="unit">M</span> 
            </div>
            <div class="day">
              <input matInput [value]="patientAge?.days" />
              <span class="unit">D</span></div>
          </div>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1">
          <mat-checkbox formControlName="isVip" [required]="mandatoryField.isVip" (change)="updateVIPStatus($event)">
            {{ "RegistrationPage.vipPatient" | translate }}
          </mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <!-- <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "aliasName" | translate }}</mat-label>
            <input
              matInput
              maxlength="50"
              style="text-transform: uppercase;"
              formControlName="aliasName"
              [placeholder]="'aliasName' | translate"
              attr.data-automation-attribute="txtAliasName"
            />
          </mat-form-field> -->
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.countryCode"
            [label]="'EncounterPage.countryCode' | translate"
            [masterName]="masterAPI.COUNTRY_CODE_MASTER"
            [formControlName]="'countryCodemobile'"
            [defaultValue]="selectedPatient ? selectedPatient.countryCode : countryCode"
            [parentForm]="formRegistration"
            [isSubmitted]="patientRegForm.submitted"
            (itemSelected)="setPatternToMobileNumber($event)"
          >
          </app-master-form-field>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.handphoneNo" | translate
            }}</mat-label>
            <input
              matInput
              minlength="mobileNoMin"
              [maxlength]="mobileNoMax"
              type="text"
              oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              [required]="mandatoryField.mobileNumber"
              formControlName="mobileNumber"
              attr.data-automation-attribute="registration - form - localcontact"
              [parentForm]="formRegistration"
             
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </form>
  <!-- (keyup)="mobileFormat($event.target.value, 'mobile')" -->
  <form
    [formGroup]="formEncounter"
    novalidate
    #patientEncounterForm="ngForm"
    attr.data-automation-attribute="formUserPersonalDetails"
  >
    <div class="flex">
      <div class="form-container" style="margin-right: 10px">
        <div class="flex">
          <div class="col-6" style="margin-left: -10px">
            <b class="section-head">{{
              "EncounterPage.encounterDetails" | translate
            }}</b>
          </div>
          <div class="col-6 right">
            <mat-checkbox formControlName="visitToDepartment">
              {{ "EncounterPage.departmentVisit" | translate }}
            </mat-checkbox>
          </div>
        </div>
        <div class="row mt-10" style="margin-left: -18px">
          <div class="col-4">
            <app-master-form-field
            [isRequired]="mandatoryField.encounterType"
              [label]="'EncounterPage.encounterType' | translate"
              [masterName]="masterAPI.ENCOUNTER_TYPE_MASTER"
              [formControlName]="'encounterType'"
              [parentForm]="formEncounter"
              [defaultValue]="encounterTypeValue"
              (itemSelected)="getDoctorReqOnEncounterType($event)"
              [isSubmitted]="patientEncounterForm.submitted"
            >
            </app-master-form-field>
          </div>

          <div class="col-8">
           
             <mat-form-field class="full-width" appearance="outline">
                    <mat-label>{{
                      "EncounterPage.speciality" | translate
                    }}</mat-label>
                    <mat-select
                      [(ngModel)]="departmentValue"
                      [disabled]="isFromAppointment"
                      [isRequired]="mandatoryField.speciality"
                      attr.data-automation-attribute="speciality"
                      formControlName="department"
                      (selectionChange)="getDoctorList($event)"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="dipartmentSearch"
                          [placeholderLabel]="'Department'"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option value="null" >{{
                        "RegistrationPage.none" | translate
                      }}</mat-option>
                      <mat-option
                        *ngFor="let option of departmentFilterList"
                        [value]="option"
                      >
                        {{ option.desc }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
          </div>
        </div>
        <div class="row mt-20" style="margin-left: -18px">
          <div class="col-4">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ "EncounterPage.doctor" | translate }}</mat-label>
              <mat-select
                id="Doctor"
                [required]="isDepartment"
                [disabled]="isFromAppointment"
                attr.data-automation-attribute="encounterDoctor"
                formControlName="doctor"
                (selectionChange)="validationOnDoctor();getSpeciality($event)"
                [defaultValue]="doctorValue"
                [parentForm]="formEncounter"
              >
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="doctorSearch"
                    [placeholderLabel]="'RegistrationPage.doctor' | translate"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option>{{
                  "RegistrationPage.none" | translate
                }}</mat-option>
                <mat-option
                  *ngFor="let option of doctorFilteredList"
                  [value]="option.code"
                >
                  {{ option.desc }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-4">
            <app-master-form-field
              [isRequired]="mandatoryField.clinic"
              [label]="'EncounterPage.clinic' | translate"
              [masterName]="masterAPI.CABIN_MASTER"
              [formControlName]="'clinic'"
              [parentForm]="formEncounter"
              [isSubmitted]="patientEncounterForm.submitted"
            >
            </app-master-form-field>
          </div>

          <div class="col-4">
            <app-master-form-field
              [isRequired]="mandatoryField.cashCounter"
              [label]="'EncounterPage.cashCounter' | translate"
              [masterName]="masterAPI.CASH_COUNTER_MASTER"
              [formControlName]="'cashCounter'"
              [parentForm]="formEncounter"
              [isSubmitted]="patientEncounterForm.submitted"
            >
            </app-master-form-field>
          </div>
        </div>
        <div class="row mt-20" style="margin-left: -18px; margin-bottom:1vh;">
          <div class="col-8">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{
                "EncounterPage.encounterremarks" | translate
              }}</mat-label>
              <textarea
                attr.data-automation-attribute="encounterRemark"
                formControlName="remarks"
                matInput
                pattern="[a-zA-Z0-9.,@-/\s]+"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{"EncounterPage.queueNumber" | translate}}</mat-label>
              <input
                    formControlName="tokenNo"
                    [(ngModel)]="tokenNoValue"
                    matInput
                    placeholder="Queue No"
                    (focusout)="onFocusOutEventOnKey($event.target.value)"
                  />
            </mat-form-field>
          </div>
          <div class="col-1">
            <div class="divbottom">
              <button
                id="Add Notes"
                (click)="addInternalNotes()"
                class="btnBlack"
                mat-mini-fab
                matTooltip="{{
                  'AddInternalNotes.internalNotes' | translate
                }}"
              >
                <mat-icon
                  class="divbottom"
                  >note_add</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="div-lg">
        <div
          class="form-container"
          attr.data-automation-attribute="divreferralDetails"
        >
          <div class="col-6">
            <b class="section-head">{{
              "EncounterPage.referralDetails" | translate
            }}</b>
          </div>

          <div class="row mt-20" style="margin-right: -15px">
            <div class="col-4">
              <app-master-form-field
              [label]="'EncounterPage.visitReason' | translate"
              [masterName]="masterAPI.REASON_MASTER_QUERY"
              [formControlName]="'visittype'"
              [parentForm]="formEncounter"
              [isSubmitted]="patientEncounterForm.submitted"
              [params]="reasonCode"
            >
            </app-master-form-field>
            </div>
            <div class="col-4">
              <app-master-form-field
                [label]="'EncounterPage.referralType' | translate"
                [masterName]="masterAPI.REFERRAL_TYPE_MASTER"
                [formControlName]="'referralType'"
                [parentForm]="formEncounter"
                (itemSelected)="getReferralList($event)"
                [isSubmitted]="patientEncounterForm.submitted"
              >
              </app-master-form-field>
            </div>
            <div class="col-4" *ngIf="!isOtherReferral">
              <app-master-form-field
                [label]="'EncounterPage.referral' | translate"
                [masterName]="masterAPI.REFERRAL_MASTER"
                [formControlName]="'referral'"
                [parentForm]="formEncounter"
                [params]="referralTypeCode"
                [isSubmitted]="patientEncounterForm.submitted"
              >
              </app-master-form-field>
            </div>
            <div class="col-4" *ngIf="isOtherReferral">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{ 'EncounterPage.referral' | translate }}</mat-label>
                <input  [(ngModel)]="othersReferral" matInput maxlength="50" oninput="this.value = this.value.replace(/[^a-zA-Z0-9\s\W]/g, '')"
                  [placeholder]="'EncounterPage.referral' | translate " [ngModelOptions]=" {standalone: true}" />
              </mat-form-field>
            </div>
          </div>
          <div class="row mt-20" style="margin-right: -15px">
            <div class="col-4">
              <app-master-form-field
              [isRequired]="true"
                [label]="'RegistrationPage.patientCategory' | translate"
                [masterName]="masterAPI.PATIENT_CATEGORY_MASTER"
                [formControlName]="'patientCategory'"
                [parentForm]="formEncounter"
                [defaultValue]="
                  selectedPatient ? selectedPatient.patientCategory : ''
                "
                [isSubmitted]="patientEncounterForm.submitted"
                (selectionChange)="getTariffList(0)"
              >
              </app-master-form-field>
            </div>
            <div class="col-8">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.placeofpractice" | translate
                }}</mat-label>
                <input
                  matInput
                  formControlName="practiceNotes"
                  [disabled]="true"
                  [placeholder]="'EncounterPage.placeofpractice' | translate"
                  attr.data-automation-attribute="encounterplaceofpractice"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row mt-20" style="margin-right: -15px;margin-bottom: 2.4vh;">
            <div class="col-4">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.reportRemark" | translate
                }}</mat-label>
                <textarea
                  formControlName="reportRemarks"
                  attr.data-automation-attribute="encounterreportRemark"
                  matInput
                  pattern="[a-zA-Z0-9.,@-/\s]+"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="col-8">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{
                  "EncounterPage.referralRemarks" | translate
                }}</mat-label>
                <textarea
                  formControlName="referralRemarks"
                  attr.data-automation-attribute="encounterreferralRemarks"
                  matInput
                  pattern="[a-zA-Z0-9.,@-/\s]+"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <form
  [formGroup]="formRegistration"
  #patientRegForm="ngForm"
  novalidate
  class="mt-10"
  attr.data-automation-attribute="formUserPersonalDetails"
>
  <div class="form-container" attr.data-automation-attribute="divIDDetails">
    <b class="section-head">{{"EncounterPage.address" | translate}}</b>
    <div class="full-content">
      <mat-grid-list cols="12" rowHeight="50px">
        <mat-grid-tile [colspan]="4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.permanentAddress" | translate
            }}</mat-label>
            <input
              matInput
              style="text-transform: uppercase;"
              [required]="mandatoryField.addressPrimary"
              formControlName="addressPrimary"
              [placeholder]="
                'RegistrationPage.permanentAddress' | translate
              "
              attr.data-automation-attribute="txtAddress"
              pattern="[a-zA-Z0-9-.,/#'_@\s]+"
            />
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.countryPrimary"
            [label]="'RegistrationPage.country' | translate"
            [masterName]="masterAPI.COUNTRY_MASTER"
            [formControlName]="'countryPrimary'"
            [parentForm]="formRegistration"
            [defaultValue]="countryValue?countryValue:defaultCountry"
            (itemSelected)="getStatePrimaryList($event, false);getCountryCode($event, true)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.statePrimary"
            [label]="'RegistrationPage.state' | translate"
            [masterName]="masterAPI.STATE_MASTER_QUERY"
            [formControlName]="'statePrimary'"
            [parentForm]="formRegistration"
            [params]="CountryCode"
            [defaultValue]="stateValue"
            (itemSelected)="getCityPrimaryList($event)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <app-master-form-field
            [isRequired]="mandatoryField.cityPrimary"
            [label]="'RegistrationPage.city' | translate"
            [masterName]="masterAPI.CITY_MASTER_QUERY"
            [formControlName]="'cityPrimary'"
            [params]="StateCode"
            [defaultValue]="cityValue"
            [parentForm]="formRegistration"
            (itemSelected)="getSubDistrictPrimaryList($event)"
            [isSubmitted]="patientRegForm.submitted"
          >
          </app-master-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{
              "RegistrationPage.zipcode" | translate
            }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="pincodePrimary"
              numberOnly
              class="example-right-align"
              [placeholder]="'RegistrationPage.zipcode' | translate"
              attr.data-automation-attribute="txtPincode"
              [required]="mandatoryField.pincodePrimary"
              pattern="[a-zA-Z0-9]+"
              (focusout)="getAddressByPostCode($event.target.value)"
            />
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
  </form>

  <div class="section-grey">
    <div class="flex mt-10">
      <div class="col-6">
        <b class="section-head" style="margin-left: -10px">{{
          "EncounterPage.payerDetails" | translate
        }}</b>
      </div>
      <div class="col-6 right">
        <button
          id="Add Payer"
          (click)="addPayer()"
          class="btnCyan"
          mat-mini-fab
          matTooltip="{{ 'payerInfo.addPayer' | translate }}"
        >
          <mat-icon >add</mat-icon>
        </button>
      </div>
    </div>

    <div class="gl-table mt-10">
      <table mat-table [dataSource]="dataSourcePayers" class="mat-elevation-z8">
        <ng-container matColumnDef="Priority">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.priority" | translate }}
          </th>
          <td
            mat-cell
            class="center"
            *matCellDef="let element; let index = index"
          >
            <label>{{ index + 1 }}</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="PayerType">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.payerType" | translate }}
            <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.payerTypeCode"
              [disabled]="element.payerTypeCode == 'SELF'"
              class="table-text full-width"
              (selectionChange)="
              getPayerTypePayer(element.payerTypeCode, index)
              "
              attr.data-automation-attribute="encounterPayer{{ index }}"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="payerTypeSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
              <mat-option
                *ngFor="let option of payerTypeList"
                [disabled]="option.isSelf"
                [value]="option.code"
              >
                {{ option.desc }} ({{ option.code }})
              </mat-option>
            </mat-select>
            <!-- <label>{{ element.payerCode }}</label> -->
          </td>
        </ng-container>
        <ng-container matColumnDef="Payer">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.payer" | translate }} <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.payerCode"
              [disabled]="element.payerTypeCode == 'SELF'"
              class="table-text full-width"
              attr.data-automation-attribute="encounterPayer{{ index }}"
              (selectionChange)="getContractPayer(element.payerCode,index);getGlType(element,index);
              getTariffList(index);"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="payerSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
              <mat-option
                *ngFor="let option of element.payerList"
                [disabled]="option.isSelf"
                [value]="option.code"
              >
                {{ option.desc }} ({{ option.code }})
              </mat-option>
            </mat-select>
            <!-- <label>{{ element.payerCode }}</label> -->
          </td>
        </ng-container>
        <ng-container matColumnDef="Tariff">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.tariff" | translate }} <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.tariffCode"
              [disabled]="element.isDisableTariff"
              class="table-text full-width"
              attr.data-automation-attribute="encounterTariff{{ index }}"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="tariffSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>
              <mat-option
                *ngFor="let option of element.tariffList"
                [value]="option.code"
                >{{ option.desc }}</mat-option
              >
            </mat-select>
          </td>
        </ng-container>

        <ng-container matColumnDef="Contract">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.contract" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.contractCode"
              class="table-text full-width"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterContract{{ index + 1 }}"
              (selectionChange)="getTariffContract(element.contractCode,index,true);"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="contractCodeSearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>

              <mat-option
                *ngFor="let option of element.contractList"
                [value]="option.code"
                >{{ option.desc }}</mat-option
              >
            </mat-select>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="AssociatedCompany">
          <th mat-header-cell *matHeaderCellDef>
            {{ "billing.associatedCompany" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.associatedCompanyCode"
              class="table-text full-width"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterAssociatedCompany{{
                index
              }}"
            >
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="associatedCompanySearch"
                  [placeholderLabel]="'RegistrationPage.search' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option>{{ "RegistrationPage.none" | translate }}</mat-option>

              <mat-option
                *ngFor="let option of associatedCompanyList"
                [value]="option.code"
                >{{ option.desc }}</mat-option
              >
            </mat-select>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="GLType">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.glType" | translate }} <span class="red">*</span>
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-select
              [(ngModel)]="element.glTypeCode"
              [disabled]="true"
              class="table-text full-width"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterGlType{{ index }}"
            >
              <mat-option
                *ngFor="let option of glTypeList"
                [value]="option.code"
                >{{ option.desc }}</mat-option
              >
            </mat-select>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="PolicyNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.policyNumber" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <input
              [(ngModel)]="element.policyNumber"
              type="text"
              class="table-text full-width"
              value=""
              maxlength="20"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterPolicyNumber{{ index }}"
              pattern="[a-zA-Z0-9]+"
            />

            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="EffectiveDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.effectiveDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <input
              matInput
              [matDatepicker]="pickerEff"
              [(ngModel)]="element.effectiveDate"
              class="table-text full-width"
              (click)="pickerEff.open()"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterEffectiveDate{{ index }}"
            />
            <mat-datepicker #pickerEff></mat-datepicker>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="expiryDate">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.glexpirydate" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element; let index = index"
            class="effective-date"
          >
            <input
              matInput
              [matDatepicker]="pickerEff"
              [(ngModel)]="element.expiryDate"
              [disabled]="true"
              class="table-text full-width effective-date-input"
              (click)="pickerEff.open()"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterEffectiveDate{{
                index
              }}"
            />
            <mat-datepicker #pickerEff></mat-datepicker>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="gLRefNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ "billing.gLRefNo" | translate }}
          </th>
          <td mat-cell   class="payer-info" *matCellDef="let element; let index = index" >
            <mat-select
              [(ngModel)]="element.glReferenceNo"
              (selectionChange)="glDetails(element.glReferenceNo,index)"
              class="table-text full-width"
              *ngIf="!element.isSelf"
              attr.data-automation-attribute="encounterGlType{{ index }}"
            >
              <mat-option value="">none</mat-option>
              <mat-option
                *ngFor="let option of referralNoList"
                [value]="option.glrefno"
                >{{ option.glrefno }}</mat-option
              >
            </mat-select>
            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="glBalance">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.glBalance" | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element; let index = index"
            class="policy-number"
          >
            <input
              [(ngModel)]="element.glAmount"
              type="text"
              class="policy-number"
              value=""
              *ngIf="!element.isSelf"
              [disabled]="true"
              attr.data-automation-attribute="encounterPolicyNumber{{
                index
              }}"
            />

            <label *ngIf="element.isSelf">NA</label>
          </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th mat-header-cell *matHeaderCellDef>
            {{ "EncounterPage.action" | translate }}
          </th>
          <td mat-cell *matCellDef="let element; let index = index">
            <mat-icon
              *ngIf="element.isSelf == false"
              (click)="removePayer(element)"
              matTooltip="{{ 'payerInfo.delete' | translate }}"
              >delete</mat-icon
            >
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsPayers sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsPayers"></tr>
      </table>
    </div>
  </div>
  <div class="section-grey" [ngClass]="{ 'dflex': isDefaultDeposit }">
    <mat-form-field appearance="outline" *ngIf="isDefaultDeposit">
      <mat-label>Default Deposit</mat-label>
      <input
            [(ngModel)]="defaultDeposit"
            matInput
            type="number"
            (input)="inputValidation.limitInputLength($event,10)"
            placeholder="Default Deposit"
          />
    </mat-form-field>
    <div class="right mt-2">
      <button
        (click)="confirmClearPatientEncounter()"
        class="btnOrange"
        mat-mini-fab
        matTooltip="{{ 'payerInfo.reset' | translate }}"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      &nbsp;
      <button
        *ngIf="isSave"
        id="Save Encounter"
        (click)="saveEncouter()"
        class="btnCyan"
        mat-mini-fab
        matTooltip="{{ 'payerInfo.save' | translate }}"
      >
        <mat-icon>sim_card</mat-icon>
      </button>
    </div>
  </div>
</div>
